// extracted by mini-css-extract-plugin
module.exports = {"dragging":"Draggable_dragging_1BX-e","draggable":"Draggable_draggable_3SZdJ","draggable-data-transfer":"Draggable_draggable-data-transfer_2TIWF"};